module.exports = __webpack_public_path__ + "static/media/ic-arrow-down-black.acd066af.svg";